(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sort"] && !Shopify.designMode) return;
  try {
    // Update the toggle text to show "Sort By: <Option>" when an option is selected
  document.addEventListener('DOMContentLoaded', function () {
    const sortSelects = document.querySelectorAll('.collection-sort__select');

    sortSelects.forEach(function (select) {
      const toggle = select.nextElementSibling;

      function updateToggleText() {
        const selectedOption = select.options[select.selectedIndex];
        const selectedText = selectedOption.text;

        // Check if it's the default "Featured" option
        if (selectedOption.value === 'manual') {
          toggle.textContent = 'Sort by +';
        } else {
          toggle.textContent = 'Sort by: ' + selectedText;
        }
      }

      // Update on page load
      updateToggleText();

      // Update when selection changes (before form submits)
      select.addEventListener('change', function () {
        updateToggleText();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["featured-collection"] && !Shopify.designMode) return;
  try {
    // HLS video support for browsers that don't natively support it
  if (typeof Hls !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function() {
      const hlsVideos = document.querySelectorAll('video source[type="application/x-mpegURL"]');
      
      hlsVideos.forEach(function(source) {
        const video = source.parentElement;
        const videoSrc = source.getAttribute('src');
        
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          // Native HLS support (Safari)
          video.src = videoSrc;
        } else if (Hls.isSupported()) {
          // Use HLS.js for browsers without native support
          const hls = new Hls({
            autoStartLoad: true,
            startLevel: -1, // Auto quality
          });
          hls.loadSource(videoSrc);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, function() {
            video.play().catch(function(error) {
              console.log('HLS autoplay prevented:', error);
            });
          });
        }
      });
    });
  } else {
    // Fallback: try to play HLS directly for Safari
    document.addEventListener('DOMContentLoaded', function() {
      const hlsVideos = document.querySelectorAll('video source[type="application/x-mpegURL"]');
      
      hlsVideos.forEach(function(source) {
        const video = source.parentElement;
        const videoSrc = source.getAttribute('src');
        
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = videoSrc;
          video.play().catch(function(error) {
            console.log('Video autoplay prevented:', error);
          });
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
